import React from 'react';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import StoryButton from '../../../../components/story-button/StoryButton';
import StoryBadge from '../../../../components/story-badge/StoryBadge';
import StoryMediaView from '../../../../components/story-media-view/StoryMediaView';
import useStoryMediaDisplay from '../../../../hooks/useStoryMediaDisplay';
import { getStoryMediaId, isStoryMediaUploading, isUploadedStoryMedia } from '../../../../media/storyMediaItem';

import scss from './SelectedMediaHeroSlide.module.scss';

function SelectedMediaHeroSlide({ media, onPreview, onRemove }) {
  const { t } = useTranslation('story');
  const { isVideo, isLoading } = useStoryMediaDisplay(media);
  const isCustom = isUploadedStoryMedia(media) && !isStoryMediaUploading(media);

  const handlePreview = () => {
    onPreview(media);
  };

  const handleRemove = (event) => {
    event.stopPropagation();
    onRemove?.(getStoryMediaId(media));
  };

  return (
    <div className={scss.slide}>
      <StoryMediaView
        media={media}
        variant='hero'
        className={scss.image}
        videoClassName={scss.video}
        imageClassName={scss.image}
      />

      {isCustom ? <StoryBadge label={t('custom')} size='sm' className={scss.customBadge} /> : null}

      {!isVideo && !isLoading ? (
        <StoryButton
          icon={OpenInFullOutlinedIcon}
          onClick={handlePreview}
          ariaLabel={t('preview')}
          className={scss.previewButton}
        />
      ) : null}

      {onRemove ? (
        <StoryButton
          icon={CloseIcon}
          onClick={handleRemove}
          ariaLabel={t('removeMedia')}
          size='sm'
          className={scss.removeButton}
        />
      ) : null}
    </div>
  );
}

export default SelectedMediaHeroSlide;
